module.exports = __webpack_public_path__ + "img/discount.b5759d5b.png";